import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from "../../services/auth/auth.service";
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(environment.apiUrl)) {
      return next.handle(request);
    }
    if (this.authService.getToken()) {
      request = request.clone({ setHeaders: { 'X-API-authentication-token': this.authService.getToken() } });
    }
    return next.handle(request).pipe(
      catchError((error) => {

        if (!request.url.endsWith('login') && error instanceof HttpErrorResponse && error.status === 401) {
          this.authService.tokenExpired();
        }

        return throwError(() => error);
      }),
    );
  }
}
